import { createStyles, makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      width: "780px",
    },
    photoRoot: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      height: "100%",
      width: "100%",
      marginRight: "20px",
      overflow: "hidden",
      position: "relative",
    },
    inputFormRoot: {
      display: "flex",
      flexDirection: "column",
    },
    avatar: {
      minWidth: "100%",
      minHeight: "308px",
    },
    avatarIE:{
      position: "relative",
      width: "100%",
      height: "308px",
      overflow: "hidden",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginRight: "20px",
      border: "1px solid #7f7f7f"
    },
    avatarIEImage: {
      height: "100%",
    },
    fieldItem: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginTop: "16px",
      marginBottom: "36px",
      width: "500px",
      height: "36px",
    },
    helperText: {
      position: "absolute",
      bottom: "-22px",
    },
    inputLabel: {
      color: theme.palette.primary.main,
    },
    fieldName: {
      marginRight: "12px",
      display: "flex",
      color: theme.palette.text.primary,
    },
    fieldContent: {
      width: "900px",
      display: "flex",
      position: "relative",
    },
    buttonBase: {
      margin: "24px 0px",
      width: "100%",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
    },
    button: {
      marginLeft: "12px",
    },
    errorTypo: {
      color: "red",
    },
    inputFile: {
      width: "0.1px",
      height: "0.1px",
      opacity: 0,
      overflow: "hidden",
      position: "absolute",
      // z-index: -1,
    },
    inputFileLabelItem: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      fontSize: "16px",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    inputFileLabelIcon: {
      marginRight: "20px",
    },
    photoMenuRoot: {
      left: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "white",
      width: "100%",
      position: "absolute",
    },
    menuOption: {
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.1)",
      },
    },
  });
export const useStyles = makeStyles(styles);
